<template>
  <!-- 通过key实现tab切换实现组件更新，否则就要实现各种tab下的数据切换 -->
  <receive-order-item
    :key="tabIndex"
    :type="tabIndex"
    @tab="onTab"
  ></receive-order-item>
</template>

<script>
/** 应收账单 */

import tableFilterValueMixins from '@/mixins/table_filterValue_mixins.js';
import receiveOrderItem from './children/receive_order_item.vue';

export default {
  name: 'receiveOrder',
  mixins: [tableFilterValueMixins],
  components: {
    receiveOrderItem
  },
  data() {
    return {
      // 1 - 待收款，2 - 已收款
      tabIndex: '1'
    };
  },
  mounted: function () {

  },
  methods: {
    onTab(value) {
      this.tabIndex = value;
    }
  },
};
</script>

<style lang="scss">
</style>
